function splitHtmlTags(elem, tag) {
	const tags = elem.querySelectorAll(tag);
	tags.forEach(item => {
		let newTags = [];
		let words = item.innerHTML.split(" ");
		words.forEach(word=>{
			newTags.push(`<${tag}>`.concat(word).concat(`</${tag}>`));
		});
		item.outerHTML = newTags.join(" ");
	});
}